export default class ResponseMapModel {
	public value: string;
	public comparison: string;
	public variableValue: string;
	public nextAction: string;

	public constructor() {
		this.value = "";
		this.comparison = "";
		this.variableValue = "";
		this.nextAction = "";
	}
}
